export const Element = {
  EDIT_BUTTON_SELECTOR: '#rmcustombutton-main-container-Edit',
} as const;
